module.exports = __webpack_public_path__ + "static/media/Logo_briktech_Name.8719be93.png";